import React from "react";

import AppChatWidget from "@/components/common/AppChatWidget";
import AppZendesk from "@/components/common/AppZendesk";

// サポートチャットの出し分け。自社ウィジェットを GCP (Cloud Run) へ移設している最中のため、
// CHAT_PROVIDER で従来の Zendesk と切り替えられるようにしてある。既定は Zendesk。
const AppChatSupport: React.FC = () => {
  if (process.env.CHAT_PROVIDER === "hinome") {
    return <AppChatWidget />;
  }
  // Zendesk はローカルから問い合わせが飛ばないよう本番・ステージング限定 (移行前の挙動)
  if (process.env.APP_ENV === "production" || process.env.APP_ENV === "staging") {
    return <AppZendesk />;
  }
  return null;
};

export default React.memo(AppChatSupport);
